import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import ConfirmCheckbox from 'views/confirm/confirm_checkbox/confirm_checkbox'
import { localize } from 'helpers/translator'
import themeTypes from 'helpers/enums/themes/themeTypes'

class LessonWithCollaborateDisabledConfirm extends PureComponent {

	launchHomework = checkboxStatus => {
		this.props.actions.launchHomeworkWithCollaborateDisabled(
			this.props.presentationUid, checkboxStatus, this.props.isNew
		)
	}

	render() {
		return <ConfirmCheckbox
			alertTitle={localize('lesson_collaborate_disabled_confirm_alert_title')}
			alertMessage={localize('lesson_collaborate_disabled_confirm_alert_message')}
			btOne={localize('lesson_collaborate_disabled_confirm_btn_continue')}
			actionOne={this.launchHomework}
			btTwo={localize('lesson_collaborate_disabled_confirm_btn_settings')}
			actionTwo={this.props.actions.openAdvancedSettings}
			checkboxLabel={localize('do_not_show_again')}
			closeButton={false}
			theme={themeTypes.LIGHT}
		/>
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		launchHomeworkWithCollaborateDisabled: myLibraryActions.launchHomeworkWithCollaborateDisabled,
		openAdvancedSettings: myLibraryActions.openSettingsCollaborateDisabled,
	}, dispatch)
}

LessonWithCollaborateDisabledConfirm.propTypes = {
	isNew: PropTypes.string.isRequired,
	presentationUid: PropTypes.string.isRequired,
	actions: PropTypes.shape({
		launchHomeworkWithCollaborateDisabled: PropTypes.func.isRequired,
		openAdvancedSettings: PropTypes.func.isRequired,
	}),
}


export default connect(null, mapDispatchToProps)(
	LessonWithCollaborateDisabledConfirm
)

export { LessonWithCollaborateDisabledConfirm }
